import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4bb757be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h1--hero" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-h-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", {
      "data-w-id": "a57a7ba6-1456-df65-733e-c340ef917366",
      class: "h--super-large"
    }, " Crypto ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "hero-h-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", {
      "data-w-id": "a57a7ba6-1456-df65-733e-c340ef917366",
      class: "h--super-large"
    }, " currency ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "hero-h-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", {
      "data-w-id": "201b457d-0993-bca7-76e5-88cdccd4a159",
      class: "h--super-large"
    }, " Exchange Notice ")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Draph Solutions s.r.o. provides cryptocurrency exchange services that can be conducted through our trusted partners. We strive to ensure a seamless and secure experience, regardless of the method used for the exchange.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please be aware that the involvement of trusted partners in the exchange process is subject to their own terms and conditions, which may differ from those of Draph Solutions s.r.o. While we diligently select and regularly review these partners for reliability and trustworthiness, Draph Solutions s.r.o. is not responsible for any actions, errors, or omissions by these partners.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "By utilizing our cryptocurrency exchange services, you acknowledge and agree that:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "litle" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, "You understand the inherent risks associated with cryptocurrency transactions, including but not limited to market volatility, regulatory changes, and potential technical issues.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Draph Solutions s.r.o. and its trusted partners do not provide investment advice, and any decision to exchange or hold cryptocurrency is made at your own discretion.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, "You accept that exchanges conducted through our trusted partners may be governed by their respective policies and procedures, and you agree to comply with any such terms.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Draph Solutions s.r.o. is not liable for any losses or damages incurred as a result of using our exchange services or those of our trusted partners.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We recommend that you thoroughly review the terms and conditions of any service provider before engaging in cryptocurrency exchanges. For any questions or concerns, please contact our customer support team at support@swipez.eu.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Draph Solutions s.r.o. reserves the right to modify this disclaimer at any time without prior notice.", -1))

import { DocumentLayout } from "@/layout";
import { ref, computed, onMounted, watch } from "vue";
// import HomeAdapterService from "./home/adapter/HomeAdapterService";

// const adapter = new HomeAdapterService();


export default /*#__PURE__*/_defineComponent({
  __name: 'CryptocurrencyExchangeNotice',
  setup(__props) {

// Импорты из Vue 3 Composition API

onMounted(async () => { });
const onShowAnswer = (id: string) => { };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DocumentLayout), null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ]),
    _: 1
  }))
}
}

})